import React from 'react'
import { useSelector } from 'react-redux'
import { ControlledTooltip } from 'components'
import Info from 'views/components/atoms/Svgs/Info'
import { portfolioApiSelectors } from '../../../../../api/portfolio'
import { partyApiSelectors } from '../../../../../api/party'
import { formatCurrency } from '../../../../../../utils/currency'
import styles from './LeaseDetails.module.scss'
interface LeaseDetailsProps {
  portfolioId: string
  depositHeld: number | null
}

const LeaseDetails = ({ portfolioId, depositHeld }: LeaseDetailsProps) => {
  const tenantId = useSelector(state => portfolioApiSelectors.getTenantByPortfolioId(state)(portfolioId))
  const tenantName = useSelector(state => partyApiSelectors.getPartyNameById(state)(tenantId))
  const rentAmount = useSelector(state => portfolioApiSelectors.getMonthlyRentAmount(state)(portfolioId))

  return (
    <div className={styles.root}>
      <div className={styles.item}>
        <span className={styles.label}>Tenant</span>
        <p className={styles.value}>{tenantName}</p>
      </div>
      <div className={styles.item}>
        <span className={styles.label}>Rental amount</span>
        <p className={styles.value}>{formatCurrency(rentAmount)}</p>
      </div>
      <div className={styles.item}>
        <span className={styles.label}>
          Deposit held
          <ControlledTooltip body="A deposit refund or transfer can be actioned from the deposit wallet." place="above">
            <span className={styles.infoIcon}>
              <Info width={16} height={16} />
            </span>
          </ControlledTooltip>
        </span>
        <p className={styles.value}>{formatCurrency(Math.round(Number(depositHeld)) || 0)}</p>
      </div>
    </div>
  )
}

export default LeaseDetails
